/**
 * Client-side checks for order/cart content documents.
 * Google Docs "Download as Microsoft Word (.docx)" often reports
 * application/octet-stream even though the file is a valid .docx.
 */

const EXTENSIONS = new Set(['pdf', 'doc', 'docx', 'txt', 'rtf']);

const KNOWN_MIME_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'application/rtf',
  'text/rtf',
]);

/** Browsers / OS often use these for exported .docx (e.g. Google Docs). */
const AMBIGUOUS_MIME_TYPES = new Set([
  '',
  'application/octet-stream',
  'binary/octet-stream',
  'application/x-download',
]);

function extensionFromFileName(name: string): string {
  const base = name.trim();
  const i = base.lastIndexOf('.');
  if (i <= 0 || i === base.length - 1) return '';
  return base.slice(i + 1).toLowerCase();
}

export function isAllowedContentDocumentFile(file: File): boolean {
  const ext = extensionFromFileName(file.name);
  if (!EXTENSIONS.has(ext)) {
    return false;
  }

  const type = (file.type || '').toLowerCase();

  if (KNOWN_MIME_TYPES.has(type)) {
    return true;
  }

  if (AMBIGUOUS_MIME_TYPES.has(type)) {
    return true;
  }

  if (
    (type === 'application/zip' || type === 'application/x-zip-compressed') &&
    ext === 'docx'
  ) {
    return true;
  }

  return false;
}

export const CONTENT_DOCUMENT_REJECT_MESSAGE =
  'Use a PDF, Word, TXT, or RTF file. From Google Docs: File → Download → Microsoft Word (.docx).';
